"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractMessagesFromEvent = exports.heartbeatMessageValue = void 0;
exports.heartbeatMessageValue = '__heartbeat__';
var extractMessagesFromEvent = function (_a) {
    var data = _a.data;
    // heartbeat ping-pong
    if (data === exports.heartbeatMessageValue) {
        return {
            messageList: []
        };
    }
    if (typeof data !== 'string') {
        return {
            error: "typeof message not handled: " + typeof data,
            messageList: []
        };
    }
    var parsedData;
    try {
        parsedData = JSON.parse(data);
    }
    catch (e) {
        parsedData = data;
    }
    if (!Array.isArray(parsedData)) {
        return {
            error: "received data is not an array of messages: " + JSON.stringify(parsedData),
            messageList: []
        };
    }
    return {
        messageList: parsedData
    };
};
exports.extractMessagesFromEvent = extractMessagesFromEvent;
